import CareLogo from "../../../assets/icons/Care32-02.png";

type CareCornerLogoProps = {
  /** `wall` = single-room / legacy full-bleed; `grid` = multi-room board with safe-area inset */
  variant: "wall" | "grid";
};

export function CareCornerLogo({ variant }: CareCornerLogoProps) {
  const className =
    variant === "grid"
      ? "pointer-events-none absolute bottom-[max(env(safe-area-inset-bottom,0px),clamp(8px,1.5vmin,20px))] right-[max(env(safe-area-inset-right,0px),clamp(10px,2vmin,28px))] z-[1] h-[clamp(40px,5.5vmin,72px)] w-auto max-w-[min(32vw,160px)] object-contain"
      : "pointer-events-none absolute bottom-[clamp(16px,2.5vmin,36px)] right-[clamp(16px,2.5vmin,36px)] h-[clamp(72px,9vmin,120px)] w-auto max-w-[min(28vmin,320px)] object-contain";

  return <img src={CareLogo} alt="" className={className} />;
}
